const connection = {
	apiKey: "AIzaSyAcSC1UYtpHcoNYNe2_S4uxuvyN8D2JiKg",
	authDomain: "smv-site-d762a.firebaseapp.com",
	databaseURL: "https://smv-site-d762a.firebaseio.com",
	projectId: "smv-site-d762a",
	storageBucket: "smv-site-d762a.appspot.com",
	messagingSenderId: "148285888146"
}

export default connection;